import {override, makeObservable} from 'mobx';
import {AutoAnimation} from "../../../../../infrastructure/models/animation/auto-animation";
import {BaseGoalAnimationSetModel} from "../../../../../infrastructure/models/animation/game/animation-set-models/goal/base-goal-animation-set-model";
import {ANIMATION_TIMES} from "../../../../../core/consts";
import styles from "../styles/game-center-header-animation.module.scss";
import classNames from "classnames";

export class GameCenterHeaderGoalAnimationSetModel extends BaseGoalAnimationSetModel {
  duration: Number;

  constructor(animation) {
    super(animation);

    makeObservable(this);

    this.duration = ANIMATION_TIMES.GAME_CENTER.goalAnimationTime;
  }

  @override get statusText(): AutoAnimation {
    const enterAnimation: String = classNames('scale-up-center-infinite', styles.text_animation);
    const mainAnimation: String = classNames('scale-up-center-infinite', styles.text_animation);
    const leaveAnimation: String = classNames('scale-up-center-infinite', styles.text_animation);

    const statusText = new AutoAnimation(enterAnimation, mainAnimation, leaveAnimation, '',
      0, this.durationByRatio(0.95), this.durationByRatio(0.05));

    return statusText;
  }

  @override get homeCompetitorLogo(): AutoAnimation {
    const enterAnimation: String = classNames('scale-up-center-disappear');
    const mainAnimation: String = classNames('hide');
    const leaveAnimation: String = classNames('scale-up-center-appear');

    const homeCompetitorLogo = new AutoAnimation(enterAnimation, mainAnimation, leaveAnimation, '',
      0, this.durationByRatio(0.95), this.durationByRatio(0.05));

    return homeCompetitorLogo;
  }

  @override get homeCompetitorEventLogo(): AutoAnimation {
    const enterAnimation: String = classNames('scale-up-center-appear', styles.goal_event_logo);
    const mainAnimation: String = classNames('visible', styles.goal_event_logo);
    const leaveAnimation: String = classNames('scale-up-center-disappear', styles.goal_event_logo);

    const homeCompetitorEventLogo = new AutoAnimation(enterAnimation, mainAnimation, leaveAnimation, '',
      0, this.durationByRatio(0.95), this.durationByRatio(0.05));


    return homeCompetitorEventLogo;
  }

  @override get homeCompetitorName(): AutoAnimation {
    const enterAnimation: String = classNames(styles.goal_competitor_name_enter);
    const mainAnimation: String = '';
    const leaveAnimation: String = classNames(styles.goal_competitor_name_leave);

    const homeCompetitorName = new AutoAnimation(enterAnimation, mainAnimation, leaveAnimation, '',
      0, this.durationByRatio(0.85), this.durationByRatio(0.05), this.durationByRatio(0.1));

    return homeCompetitorName;
  }

  @override get homeCompetitorPlayerName(): AutoAnimation {
    const enterAnimation: String = classNames('fade-in');
    const mainAnimation: String = '';
    const leaveAnimation: String = classNames('fade-out');

    const homeCompetitorPlayerName = new AutoAnimation(enterAnimation, mainAnimation, leaveAnimation, '',
      0, this.durationByRatio(0.85), this.durationByRatio(0.05), this.durationByRatio(0.1));

    return homeCompetitorPlayerName;
  }

  @override get homeCompetitorScore(): AutoAnimation {
    const enterAnimation: String = classNames(styles.goal_competitor_score_enter);
    const mainAnimation: String = '';
    const leaveAnimation: String = classNames(styles.goal_competitor_score_leave);

    const homeCompetitorScore = new AutoAnimation(enterAnimation, mainAnimation, leaveAnimation, '',
      0, this.durationByRatio(0.85), this.durationByRatio(0.05), this.durationByRatio(0.1));

    return homeCompetitorScore;
  }

  @override get awayCompetitorLogo(): AutoAnimation {
    const enterAnimation: String = classNames('scale-up-center-disappear');
    const mainAnimation: String = classNames('hide');
    const leaveAnimation: String = classNames('scale-up-center-appear');

    const awayCompetitorLogo = new AutoAnimation(enterAnimation, mainAnimation, leaveAnimation, '',
      0, this.durationByRatio(0.95), this.durationByRatio(0.05));


    return awayCompetitorLogo;
  }

  @override get awayCompetitorEventLogo(): AutoAnimation {
    const enterAnimation: String = classNames('scale-up-center-appear', styles.goal_event_logo);
    const mainAnimation: String = classNames('visible', styles.goal_event_logo);
    const leaveAnimation: String = classNames('scale-up-center-disappear', styles.goal_event_logo);

    const awayCompetitorEventLogo = new AutoAnimation(enterAnimation, mainAnimation, leaveAnimation, '',
      0, this.durationByRatio(0.95), this.durationByRatio(0.05));

    return awayCompetitorEventLogo;
  }

  @override get awayCompetitorName(): AutoAnimation {
    const enterAnimation: String = classNames(styles.goal_competitor_name_enter);
    const mainAnimation: String = '';
    const leaveAnimation: String = classNames(styles.goal_competitor_name_leave);

    const awayCompetitorName = new AutoAnimation(enterAnimation, mainAnimation, leaveAnimation, '',
      0, this.durationByRatio(0.85), this.durationByRatio(0.05), this.durationByRatio(0.1));

    return awayCompetitorName;
  }

  @override get awayCompetitorPlayerName(): AutoAnimation {
    const enterAnimation: String = classNames('fade-in');
    const mainAnimation: String = '';
    const leaveAnimation: String = classNames('fade-out');

    const awayCompetitorPlayerName = new AutoAnimation(enterAnimation, mainAnimation, leaveAnimation, '',
      0, this.durationByRatio(0.85), this.durationByRatio(0.05), this.durationByRatio(0.1));

    return awayCompetitorPlayerName;
  }

  @override get awayCompetitorScore(): AutoAnimation {
    const enterAnimation: String = classNames('game-center-header-goal-animation-competitor-score-enter');
    const mainAnimation: String = '';
    const leaveAnimation: String = classNames('game-center-header-goal-animation-competitor-score-leave');

    const awayCompetitorScore = new AutoAnimation(enterAnimation, mainAnimation, leaveAnimation, '',
      0, this.durationByRatio(0.85), this.durationByRatio(0.05), this.durationByRatio(0.1));

    return awayCompetitorScore;
  }
}
